import React from 'react';

import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import {useIntl} from 'react-intl';

import {ArrowIcon, Button, Heading} from '@edume/magnificent';

import MessageBubbleHeader from '../../../components/Login/MessageBubbleHeader';
import LoginDisplay from '../../../components/LoginDisplay';
import useBreakpoint from '../../../hooks/useBreakpoint';
import SimpleMessageView from '../../landing/SimpleMessageView';

import styles from './styles.module.scss';

const ErrorPage = ({backToSignIn, showButton, title, description}) => {
  const {isSmallScreen} = useBreakpoint();
  const intl = useIntl();

  return (
    <LoginDisplay>
      <SimpleMessageView darkBackground={isSmallScreen} isMainLandmark={false}>
        <MessageBubbleHeader />
        <div styleName='container'>
          <Heading as='h3' size='sheep'>
            {intl.formatMessage({id: title})}
          </Heading>
          {description && (
            <Heading size='ant' as='legacy-span'>
              <div
                styleName='headerContainer'
                dangerouslySetInnerHTML={{
                  __html: intl.formatMessage({
                    id: description,
                  }),
                }}
              />
            </Heading>
          )}
        </div>
        <div styleName='buttonContainer'>
          {showButton && (
            <Button
              type='primary'
              submit
              iconPosition='start'
              icon={<ArrowIcon colour='primary' />}
              onClick={backToSignIn}
            >
              {intl.formatMessage({
                id: 'OtpLogin.Error.button',
              })}
            </Button>
          )}
        </div>
      </SimpleMessageView>
    </LoginDisplay>
  );
};

ErrorPage.propTypes = {
  backToSignIn: PropTypes.func.isRequired,
  showButton: PropTypes.bool,
  title: PropTypes.string,
  description: PropTypes.string,
};

export default CSSModules(ErrorPage, styles);
